import {Component, OnDestroy, OnInit} from '@angular/core';
import {BookingV2ManagerService} from '../../services/booking-v2-manager.service';
import {BookingV2DataService} from '../../services/booking-v2-data.service';
import {Subscription} from 'rxjs';
import {AppConfigService} from "../../../../services/app-config.service";

@Component({
  selector: 'app-booking-header-desktop',
  templateUrl: './booking-header-desktop.component.html',
  styleUrls: ['./booking-header-desktop.component.scss'],
})
export class BookingHeaderDesktopComponent implements OnInit, OnDestroy {
  public logoUrl: string;
  public providerName: string;
  private subscriptions: Subscription[] = [];

  constructor(
    private bookingManager: BookingV2ManagerService,
    private bookingData: BookingV2DataService,
    private appConfigService: AppConfigService
  ) {
    this.logoUrl = `${appConfigService.appConfig.amazonS3Url}assets/varden-logo-nocross.svg`;
  }

  public ngOnInit(): void {
    this.setListeners();
  }

  public ngOnDestroy() {
    this.subscriptions.forEach((sub: Subscription) => sub.unsubscribe());
  }

  public closeBooking(): void {
    this.bookingManager.closeBooking();
  }

  public navigateToCareproviderUnit(): void {
    this.bookingManager.navigateToCareproviderUnit(false);
  }

  private setListeners(): void {
    this.subscriptions.push(
      this.bookingData.providerDetails$.subscribe(
        (result) => (this.providerName = result?.name)
      )
    );
  }
}
